var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "simple__block" }, [
    _c("h3", { staticClass: "h5" }, [
      _vm._v(_vm._s(_vm.get_translation_constant("text_transaction_history"))),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12 col-md-6" }, [
        _c(
          "div",
          { staticClass: "form__col" },
          [
            _c(
              "multiselect",
              {
                attrs: {
                  multiple: false,
                  placeholder: _vm.get_translation_constant(
                    "text_all_transactions"
                  ),
                  options: _vm.transactionsTypes,
                  label: "title",
                  selectLabel: "",
                  deselectLabel: "",
                  optionHeight: 48,
                  showPointer: true,
                  searchable: false,
                },
                model: {
                  value: _vm.transaction_type_id,
                  callback: function ($$v) {
                    _vm.transaction_type_id = $$v
                  },
                  expression: "transaction_type_id",
                },
              },
              [void 0],
              2
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-12 col-md-6" }, [
        _c("div", { staticClass: "form__col" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.search,
                expression: "search",
              },
            ],
            staticClass: "form__control form__search",
            attrs: {
              id: "search",
              name: "search",
              type: "text",
              placeholder: _vm.get_translation_constant("text_search"),
            },
            domProps: { value: _vm.search },
            on: {
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.search = $event.target.value
              },
            },
          }),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("table", { staticClass: "table table__transaction" }, [
      _c(
        "tbody",
        _vm._l(_vm.filteredTransactions, function (transaction, index) {
          return _c("transaction-item", {
            key: index,
            attrs: {
              transaction: transaction,
              currencies: _vm.currencies,
              paymentoperations: _vm.paymentoperations,
              paymentmethods: _vm.paymentmethods,
              transactionsTypes: _vm.transactionsTypes,
            },
          })
        }),
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }